module.exports = __webpack_public_path__ + "img/io.faf3b249.svg";